import { ADD_FILE_REQUEST, ADD_FILE_FAILURE } from '../../../actions/api/file';
import {
  CHANGE_PHOTO_INITIALIZE,
  CHANGE_PHOTO_ADD_PHOTO,
  CHANGE_PHOTO_CHANGE_ERROR
} from '../../../actions/page/profile/ChangePhoto';

export default function ChangePhoto(state = {}, action) {
  switch (action.type) {
    case CHANGE_PHOTO_INITIALIZE:
      const defaults = {
        errorMessage: '',
        saving: false
      };
      return {
        ...state,
        ...defaults
      };
    case CHANGE_PHOTO_ADD_PHOTO:
      return {
        ...state,
        photo: action.photo,
        errorMessage: ''
      };
    case CHANGE_PHOTO_CHANGE_ERROR:
      return {
        ...state,
        errorMessage: action.errorMessage
      };
    case ADD_FILE_REQUEST:
      return {
        ...state,
        saving: true
      };
    case ADD_FILE_FAILURE:
      return {
        ...state,
        errorMessage: `Upload failed: ${action.error}`
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./js/reducers/page/XProfile/ChangePhoto.js